import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Button, Group } from "@mantine/core";
import { SatoshiConverterStoreContext } from "../stores/SatoshiConverterStore";
import { TRANSLATIONS } from "../helpers/translations";
import ServerRenderedBlock, {
  hasServerRenderedBlock,
} from "../../helpers/ServerRenderedBlock";

const LanguageToggle = observer(() => {
  const store = useContext(SatoshiConverterStoreContext);

  // Rails renders the links (layouts/_tool_shell) so the H1 below doesn't move on mount
  if (hasServerRenderedBlock("ssr-converter-langs")) {
    return <ServerRenderedBlock id="ssr-converter-langs" />;
  }
  if (!store.hasLanguageToggle) return null;

  const currentLocale = store.effectiveLocale;
  const languages = store.availableLanguages;

  return (
    <Group gap="xs" justify="center" wrap="wrap">
      {/* English (base) link — always first */}
      <Button
        component="a"
        href={store.languageUrl("en")}
        size="compact-sm"
        variant={currentLocale === "en" ? "filled" : "outline"}
        color="orange"
        styles={{ root: { fontWeight: currentLocale === "en" ? 700 : 400 } }}
      >
        English
      </Button>
      {/* One link per available language */}
      {languages.map((lang) => {
        const label = TRANSLATIONS[lang]?.label ?? lang;
        const isActive = currentLocale === lang;
        return (
          <Button
            key={lang}
            component="a"
            href={store.languageUrl(lang)}
            size="compact-sm"
            variant={isActive ? "filled" : "outline"}
            color="orange"
            styles={{ root: { fontWeight: isActive ? 700 : 400 } }}
          >
            {label}
          </Button>
        );
      })}
    </Group>
  );
});

export default LanguageToggle;
